module.exports = __webpack_public_path__ + "img/psw-2024.c9c01746.jpg";